import { Icon } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import StringInput from "components/Atoms/StringInput"
import React from "react"

type VariablesProps = {
  list: any[]
  onAdd: (value: { key: ""; value: "" }) => void
  onRemove: (idx: number) => void
  className?: string
  disabled?: boolean
}
const Variables = ({
  list,
  onAdd,
  disabled,
  onRemove,
  className = null,
}: VariablesProps) => {
  // const addItem = useNotificationTemplateStore(store => store.addListItem)
  // const removeItem = useNotificationTemplateStore(store => store.removeListItem)
  // const list = useNotificationTemplateStore(
  //   store => store.data.providerVariables
  // )
  return (
    <>
      <div className={className}>
        {list?.map?.((_, idx) => {
          return (
            <div key={idx} className="flex mb-2 bg-gray-100 p-3">
              <StringInput
                className="w-full mr-3"
                path={`providerVariables.${idx}.key`}
                placeholder="Enter Info"
                label="Key"
                big={false}
              />
              <StringInput
                className="w-full mr-3"
                placeholder="Enter Info"
                label="Value"
                big={false}
                path={`providerVariables.${idx}.value`}
              />
              <div className="flex items-end">
                <Icon
                  aria-disabled={disabled}
                  className="cursor-pointer hover:opacity-90 mb-2"
                  onClick={disabled ? null : () => onRemove(idx)}
                  icon="trash"
                  intent={disabled ? "none" : "danger"}
                />
              </div>
            </div>
          )
        })}
      </div>
      <CustomButton
        disabled={disabled}
        intent="success"
        outlined
        onClick={() => onAdd({ key: "", value: "" })}
        className="mt-3"
        icon="plus"
      >
        Key Name
      </CustomButton>
    </>
  )
}

export default Variables
